"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMilestone = getMilestone;
exports.getAward = getAward;
const milestonejson = require("@/genfiles/milestones.json");
const awardjson = require("@/genfiles/awards.json");
const milestones = {};
const awards = {};
milestonejson.forEach((e) => {
    milestones[e.name] = e;
});
awardjson.forEach((e) => {
    awards[e.name] = e;
});
function getMilestone(name) {
    return milestones[name];
}
function getAward(name) {
    return awards[name];
}
